<template>
    <div>
        <p class="text-body-2 mb-4">
            Selecciona el archivo SCL (.xlsx). El archivo debe contener una sola hoja.
            Se generará una previsualización de los encabezados y una muestra de filas
            antes de procesar los datos.
        </p>

        <v-file-input
            label="Archivo SCL"
            accept=".xlsx"
            :error-messages="fileError"
            variant="outlined"
            prepend-icon="mdi-file-excel"
            :loading="loading"
            :disabled="loading"
            clearable
            @update:model-value="onFile"
        ></v-file-input>

        <div v-if="loading" class="d-flex align-center justify-center mt-4">
            <v-progress-circular indeterminate color="indigo-darken-3" size="32" width="4"></v-progress-circular>
            <span class="ml-3 text-body-2">Generando previsualización...</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ImportUploadStep',
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return { fileError: '' };
        },
        methods: {
            onFile (files) {
                this.fileError = '';
                const file = Array.isArray(files) ? files[0] : files;
                if (file) {
                    if (!/\.xlsx$/i.test(file.name)) {
                        this.fileError = 'Solo se permiten archivos XLSX.';
                        return;
                    }
                    this.$emit('file-selected', file);
                }
            },
        },
    };
</script>
